import http from "./httpService";
import { getConfig } from "../config/config.js";

const config = getConfig();
const serviceEndpoint = config.apiEndpoint + "/modulos";

// console.log(localStorage.getItem("token"));

export async function getModulos() {
  try {
    http.defaults.headers.common["Authorization"] = localStorage.getItem("token");
    const response = await http.get(serviceEndpoint);
    return response.data.records;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}
